<template>
    <div>
        <PageTitle title="Selecciona la sesion para liberar tu asiento"/>
        <section class="padding-vertical-content">
            <div class="container">
                <div style="padding: 50px;" v-if="loading">
                    <LoaderComponent/>
                </div>
                <div class="row justify-content-end">
                    <Button @click="$router.go(-1)">{{$t('perfil.asiento_liberado_atras')}}</Button>
                </div>
                <div v-if="sesiones && sesiones.length > 0">
                    <span class="title">
                        {{$t('perfil.asiento_liberado_terminos_club')}}
                    </span>
                    <div class="row mt-4">
                        <div class="col-12">
                            <ul class="row matches">
                                <div v-for="sesion in sesiones" :key="sesion.id">
                                    <button :disabled="sesion.asiento_liberado" class="button large-button effect-button ml-3" @click.prevent="showModal('liberarAsiento', sesion)">{{sesion.fecha}} {{sesion.hora}} {{sesion.asiento_liberado ? 'LIBERADO' : ''}}</button>
                                </div>
                            </ul>
                        </div>
                    </div>
                    <ModalConfirmation @liberar="liberarAsiento()" v-on:close="closeModal('liberarAsiento')"/>
                </div>
                <div class="row mt-4 text-center" v-else>
                    <h2>{{$t('perfil.asiento_liberado_no_sesion')}}</h2>
                </div>
            </div>
        </section>
    </div>
    
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import ModalConfirmation from "@/components/frontend/perfil/liberar_asientos/components/ModalConfirmation";
    export default {
        data() {
            return {
                loading: false,
                mensaje: '',
                sesiones: null,
                evento_id :this.$route.params.evento_id,
                abono_id: this.$route.params.abono_id,
                sesion: null
            }
        },
        methods: {
            getSesiones() {
                this.loading = true
                const params = {
                    filters : {
                        abonado_id: this.abono_id,
                        evento_id: this.evento_id

                    },
                    abonado_id: this.abono_id,
                    evento_id: this.evento_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.abono.liberar-asientos.event.session'), params).then(res => {
                    this.sesiones = res.data.data;
                    this.loading = false;
                });

            },

            liberarAsiento() {
                this.loading = true;

                const params = {
                    filters : {
                        evento_id: this.evento_id,
                        sesion_id: this.sesion.id,
                        abonado_id: this.abono_id
                    },
                    evento_id: this.evento_id,
                    sesion_id: this.sesion.id,
                    abonado_id: this.abono_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.abono.liberar-asientos'), params).then(res => {
                    this.mensaje = res.data.message.message;
                    this.$toast.success(res.data.message.message);
                }).catch(error => {
                    this.mensaje = error.response.data.message.error;
                    this.$toast.error(error.response.data.message.error);
                }).finally(() => this.loading = false, this.getSesiones());
            },

            showModal(modal , sesion) {
                this.sesion = sesion;
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        created() {
            if(!this.isLogged){
                this.$router.push({name: 'login'});
            }
            this.getSesiones();
        },
        computed: {
            isLogged() {
                return this.$store.getters.isLogged;
            }
        },
        components: {
            PageTitle, ModalConfirmation
        }
    }
</script>